import { Button, List, Box, Typography, Paper, Container } from "@mui/material";
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import React, { useState, useEffect, useRef } from "react";
import api from "../api";
import { useNavigate } from "react-router-dom";

const EmployeeListView = (props) => {

    const [employees, setEmployees] = useState([])
    const [selectedIndex, setSelectedIndex] = React.useState(null);
    let navigate = useNavigate();

    useEffect(() => {
        getEmployees()

    }, [])


    const getEmployees = async () => {
        let res = await api.get("/employees_admin/")
        setEmployees(res.data.employees)
    }

    const handleListItemClick = (e, index, id) => {
        navigate("./employee/" + id)
    }

    return (
        <Container maxWidth={"xl"} sx={{ pt: 2, pb: 2 }}>
            <Typography textAlign={"center"} sx={{ pb: 1 }} variant="h1" >Gestion des employés</Typography>

            <Box
                boxSizing="border-box"
                display="flex"
                flexDirection="column"
                style={{ padding: "10px 64px", height: "100%" }}
            >
                <Button style={{ margin: "10px 10px 10px 0px", width: "fit-content" }} component="a" onClick={() => navigate("./employee/")} color="success" variant="contained">Ajouter un employé</Button>
                <Paper elevation={3} sx={{}}>
                    <List
                        sx={{
                            width: '100%',
                            bgcolor: 'background.paper',
                            overflowY: 'auto',
                            height: "70vh",
                            position: "relative",
                            '& ul': { padding: 0 },
                        }}
                    >
                        {employees.map((em, idx) =>
                            <ListItemButton
                                key={em.id}
                                selected={selectedIndex === idx}
                                onClick={(event) => handleListItemClick(event, idx, em.id)}
                            >
                                <ListItemText primary={em.name} secondary={`Numéro d'employé: ${em.number}`} />

                            </ListItemButton>

                        )}
                    </List>
                </Paper>
            </Box>
        </Container>
    )
}
export default EmployeeListView